import { useEffect, useState } from "react";
import { Modal, Radio, Button, Input } from "antd";

const PaymentModal = ({ isOpen, onClose }) => {
  const paymentMethods = ["UPI", "Credit/Debit Card", "Net Banking"];
  const [selectedMethod, setSelectedMethod] = useState(paymentMethods[0]);
  const [amount, setAmount] = useState(""); // User-entered amount
  const [paymentDetails, setPaymentDetails] = useState({}); // Dynamic payment details

  useEffect(() => {
    if (!isOpen) return;
    setPaymentDetails({}); // Reset fields when modal opens
  }, [isOpen]);

  // Handle payment based on selected method
  const handlePayment = () => {
    if (!amount || isNaN(amount) || amount <= 0) {
      alert("Please enter a valid amount.");
      return;
    }

    const options = {
      key: "YOUR_RAZORPAY_KEY", // Replace with your Razorpay Key
      amount: amount * 100, // Razorpay accepts amount in paise
      currency: "INR",
      name: "Donate Great",
      description: "Donation Payment",
      handler: function (response) {
        alert(
          "Payment Successful! Payment ID: " + response.razorpay_payment_id
        );
        onClose();
      },
      prefill: {
        email: "donor@example.com",
        contact: "9999999999",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const razor = new window.Razorpay(options);
    razor.open();
  };

  // Handle input change for additional details
  const handleDetailChange = (key, value) => {
    setPaymentDetails((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Modal
      title="Make a Donation"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
    >
      <div className="flex flex-col space-y-4">
        {/* Amount Input */}

        {/* Payment Method Selection */}
        <Radio.Group
          value={selectedMethod}
          onChange={(e) => setSelectedMethod(e.target.value)}
        >
          {paymentMethods.map((method) => (
            <Radio key={method} value={method}>
              {method}
            </Radio>
          ))}
        </Radio.Group>

        {/* Conditional Inputs Based on Payment Method */}
        {selectedMethod === "UPI" && (
          <Input
            type="text"
            placeholder="Enter UPI ID (e.g., user@upi)"
            value={paymentDetails.upiId || ""}
            onChange={(e) => handleDetailChange("upiId", e.target.value)}
          />
        )}

        {selectedMethod === "Credit/Debit Card" && (
          <>
            <Input
              type="text"
              placeholder="Card Number"
              value={paymentDetails.cardNumber || ""}
              onChange={(e) => handleDetailChange("cardNumber", e.target.value)}
            />
            <Input
              type="text"
              placeholder="Expiry Date (MM/YY)"
              value={paymentDetails.expiry || ""}
              onChange={(e) => handleDetailChange("expiry", e.target.value)}
            />
            <Input
              type="password"
              placeholder="CVV"
              value={paymentDetails.cvv || ""}
              onChange={(e) => handleDetailChange("cvv", e.target.value)}
            />
          </>
        )}

        {selectedMethod === "Net Banking" && (
          <Input
            type="text"
            placeholder="Enter Bank Name"
            value={paymentDetails.bank || ""}
            onChange={(e) => handleDetailChange("bank", e.target.value)}
          />
        )}

        <Input
          type="number"
          placeholder="Enter amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />

        {/* {selectedMethod === "Wallet" && (
          <Input
            type="text"
            placeholder="Enter Wallet ID"
            value={paymentDetails.walletId || ""}
            onChange={(e) => handleDetailChange("walletId", e.target.value)}
          />
        )} */}

        {/* Payment Buttons */}
        <Button
          type="primary"
          onClick={handlePayment}
          className="bg-btn-1 text-white"
        >
          Proceed to Pay ₹{amount || "0"}
        </Button>
        <Button onClick={onClose} className="border-gray-400">
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default PaymentModal;
